import React, { useEffect, useMemo, useRef, useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import Calendar from "../common/Calendar";
import dayGridPlugin from "@fullcalendar/daygrid";
import { monthNames } from "../../utils/dateUtils";
import { useDispatch, useSelector } from "react-redux";
import { handleDeleteConfirmationModal } from "../../redux/slice/modalSlice";
import DeleteConfirmationModal from "../common/DeleteConfirmationModal";
import { toggleFavouriteStatus } from "../../redux/slice/buyerSlice";
import { toggleBidFavouriteStatus } from "../../redux/slice/bidSlice";
import { togglePropertyLike } from "../../redux/action/sellerAction";
import { fetchPropertyEvent } from "../../redux/action/eventAction";
import {
    handleSelectedEvent,
    toggleEventFavouriteStatus,
} from "../../redux/slice/eventSlice";
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import useTranslationHook from "../hooks/useTranslationHook";
import HorizontalView from "./horizontalView/HorizontalView";
import { createSlug } from "../../helpers";
import Tooltip from "rc-tooltip";
import interactionPlugin from "@fullcalendar/interaction";
import Tabs from "../common/Tabs";
import DiscoverCard from "../home/common/DiscoverCard";
import useSocketSync from "../hooks/useSocketSync";
import { expandEventsDaily, filterEventsByWeekAndDay } from "../../utils";
const Events = () => {
    const { t } = useTranslationHook();
    const dispatch = useDispatch();
    const skipNextDatesSet = useRef(true);

    const user = useSelector((state) => state.auth.user);
    let lang = useSelector((state) => state.translation.lang);
    const [isHorizontal, setIsHorizontal] = useState(true);
    const [eventDate, setEventDate] = useState();
    const [todayEvents, setTodayEvents] = useState([]);
    const propertiesEvent = useSelector((state) => state.event.propertiesEvent);
    const discoverData = useSelector((state) => state.discover.discoverData);
    const selectedEvent = useSelector((state) => state.event.selectedEvent);
    const [selectedDay, setSelectedDay] = useState(null);
    const effectiveDay = selectedDay ?? new Date();
    const selectedDayRef = useRef(null);
    const todayInitializedRef = useRef(false);

    useEffect(() => {
        selectedDayRef.current = selectedDay;
    }, [selectedDay]);

    const sliderSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1367,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 568,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    const submitReaction = (id, isLiked = false) => {
        const formData = {
            domain: 3,
            property: id || selectedEvent,
            ...(user?.user_id && { user: Number(user.user_id) }),
        };
        dispatch(togglePropertyLike(formData));

        dispatch(
            toggleEventFavouriteStatus(
                propertiesEvent?.events.map((ele) =>
                    ele.id === (id || selectedEvent)
                        ? { ...ele, liked: !ele.liked }
                        : ele
                )
            )
        );

        toast.success(
            t(`${isLiked ? "Added to" : "Removed from"} favourite list`)
        );
    };

    // useEffect(() => {
    //     const today = new Date();
    //     handleWeekChange({ start: today, end: today }, true, true);
    // }, []);

    useEffect(() => {
        const start = moment().startOf("week").toDate();
        const end = moment().endOf("week").toDate();

        handleWeekChange({ start, end }, false, true);
    }, []);

    const handleWeekChange = async (info, isHorizontal, initial = false) => {
        setSelectedDay(null);
        if (JSON.stringify(eventDate) !== JSON.stringify(info)) {
            setEventDate(info);
            // const startDate = moment(initial ? new Date() : info?.start).format(
            //     "YYYY-MM-DD"
            // );
            const startDate = moment(info?.start).format("YYYY-MM-DD");
            // const endDate = isHorizontal
            //     ? startDate
            //     : moment(info?.end).subtract(1, "day").format("YYYY-MM-DD");

            const endDate = initial
                ? moment(info?.end).format("YYYY-MM-DD")
                : isHorizontal
                  ? startDate
                  : moment(info?.end).subtract(1, "day").format("YYYY-MM-DD");

            await dispatch(
                fetchPropertyEvent(
                    {
                        site_id: 3,
                        ...(user?.user_id && { user_id: user.user_id }),
                        start_date: startDate
                            ? startDate
                            : moment()
                                  .startOf("week")
                                  .utcOffset(0)
                                  .format("YYYY-MM-DD"),
                        end_date: endDate
                            ? endDate
                            : moment()
                                  .endOf("week")
                                  .utcOffset(0)
                                  .format("YYYY-MM-DD"),
                    },
                    {},
                    lang
                )
            );
        }
    };

    useEffect(() => {
        if (todayInitializedRef.current || !propertiesEvent?.events?.length)
            return;

        const today = moment().startOf("day");

        const todayOnly = propertiesEvent.events.filter((event) => {
            const start = moment(event.start).startOf("day");
            const end = moment(event.end).startOf("day").subtract(1, "day");

            return (
                start.isSameOrBefore(today, "day") &&
                end.isSameOrAfter(today, "day")
            );
        });

        setTodayEvents(todayOnly.filter((e) => e?.property_id));
        todayInitializedRef.current = true;
    }, [propertiesEvent?.events]);

    const filteredCurrentData = useMemo(() => {
        if (!eventDate) return [];

        return filterEventsByWeekAndDay(
            propertiesEvent?.events || [],
            moment(eventDate.start),
            moment(eventDate.end).subtract(1, "day"),
            selectedDay
        ).filter((e) => e?.property_id);
    }, [propertiesEvent?.events, eventDate, selectedDay]);

    const todayBaseData = useMemo(() => {
        return todayEvents.filter((e) => e?.property_id);
    }, [todayEvents]);

    const currentBaseData = useMemo(() => {
        return filteredCurrentData.filter((e) => e?.property_id);
    }, [filteredCurrentData]);

    const socketBaseData = useMemo(() => {
        const map = new Map();

        (propertiesEvent?.events || []).forEach((e) => {
            if (e?.property_id && !map.has(e.property_id)) {
                map.set(e.property_id, e);
            }
        });

        return Array.from(map.values());
    }, [propertiesEvent?.events]);

    const [socketReadyData, setSocketReadyData] = useState(null);

    useEffect(() => {
        if (propertiesEvent?.events?.length) {
            setSocketReadyData(socketBaseData);
        }
    }, [propertiesEvent?.events, socketBaseData]);

    const socketData = useSocketSync(
        socketReadyData,
        user?.user_id,
        "discoverSync"
    );

    const calendarEvents = useMemo(() => {
        if (!propertiesEvent?.events?.length) return [];
        return expandEventsDaily(propertiesEvent.events);
    }, [propertiesEvent?.events]);

    const cards = (data, section) => {
        if (!Array.isArray(data) || data.length === 0) return null;

        return data.map((ele) => {
            const socketItem = socketData?.find(
                (s) => Number(s.property_id) === Number(ele.property_id)
            );

            const mergedEle = {
                ...ele,
                ...(socketItem || {}),
                property_name: ele.title ?? "",
                property_name_ar: ele.title_ar ?? "",
            };

            return (
                <DiscoverCard
                    key={ele.property_id}
                    ele={mergedEle}
                    syncData={socketItem ?? null}
                    view={isHorizontal ? "list" : "grid"}
                    layout="calendar"
                    section={section}
                />
            );
        });
    };

    return (
        <>
            <section className="events-wrap">
                <div className="container py-5">
                    <div className="row">
                        <div
                            className="col-lg-12 wow fadeInUp"
                            data-wow-delay="0.5s"
                        >
                            <div className="main-heading">
                                <h3>{t("Auction Calendar")}</h3>
                                <ul
                                    className="nav nav-pills"
                                    id="pills-tab1"
                                    role="tablist"
                                >
                                    <li
                                        className="nav-item "
                                        role="presentation"
                                    >
                                        <button
                                            className="nav-link active"
                                            onClick={() => {
                                                setIsHorizontal(true);
                                                setSelectedDay(null);
                                            }}
                                            id="event-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#event-h-tab"
                                            type="button"
                                            role="tab"
                                        >
                                            <img
                                                src="img/event-h-icon.svg"
                                                alt="event-h-icon"
                                            />
                                        </button>
                                    </li>
                                    <li
                                        className="nav-item"
                                        role="presentation"
                                    >
                                        <button
                                            className="nav-link"
                                            id="live-tab"
                                            onClick={() => {
                                                setIsHorizontal(false);
                                                setSelectedDay(null);
                                            }}
                                            data-bs-toggle="pill"
                                            data-bs-target="#event-v-tab"
                                            type="button"
                                            role="tab"
                                            aria-controls="pills-profile"
                                            aria-selected="false"
                                        >
                                            <img
                                                src="img/event-v-icon.svg"
                                                alt="event-h-icon"
                                            />
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            {todayEvents.length > 0 && (
                                <div className="tab-content mb20">
                                    <div className="event-heading">
                                        <h5>
                                            Today
                                            <span>
                                                {moment().format("DD MMM YYYY")}
                                            </span>
                                        </h5>
                                    </div>

                                    <div
                                        className={`calender-list ${isHorizontal ? "list" : "grid grid-top"}`}
                                    >
                                        {isHorizontal ? (
                                            cards(todayBaseData, "today")
                                        ) : (
                                            <Slider {...sliderSettings}>
                                                {cards(todayBaseData, "today")}
                                            </Slider>
                                        )}
                                    </div>
                                </div>
                            )}

                            <div
                                className={`tab-content ${isHorizontal ? "list-view" : ""}`}
                                id="pills-tabContent1"
                            >
                                <h5>
                                    {t(isHorizontal ? "This Week" : "Weekly")}
                                </h5>
                                <div className="horizontal-view">
                                    <Calendar
                                        locale={lang}
                                        plugins={[
                                            dayGridPlugin,
                                            interactionPlugin,
                                        ]}
                                        eventDisplay="block"
                                        eventOverlap={false}
                                        fixedWeekCount={false}
                                        headerToolbar={{
                                            right: "prev,next",
                                        }}
                                        initialView={"dayGridWeek"}
                                        dayMaxEvents={false}
                                        events={calendarEvents}
                                        views={{
                                            dayGridWeek: {
                                                dayHeaderFormat: {
                                                    weekday: isHorizontal
                                                        ? "long"
                                                        : "narrow",
                                                },
                                                titleFormat: (
                                                    { start, end },
                                                    locale = lang
                                                ) => {
                                                    const startDate =
                                                        moment(start).locale(
                                                            locale
                                                        );
                                                    const endDate =
                                                        moment(end).locale(
                                                            locale
                                                        );

                                                    return `${startDate.format("DD")} - ${endDate.format("DD MMMM YYYY")}`;
                                                },
                                            },
                                        }}
                                        height={isHorizontal ? 80 : 500}
                                        displayEventTime={false}
                                        datesSet={(info) => {
                                            if (skipNextDatesSet.current) {
                                                skipNextDatesSet.current = false;
                                                return;
                                            }
                                            handleWeekChange(
                                                info,
                                                false,
                                                false
                                            );
                                        }}
                                        dayHeaderClassNames={(arg) => {
                                            if (!selectedDay) return [];
                                            return moment(arg.date).isSame(
                                                selectedDay,
                                                "day"
                                            )
                                                ? ["fc-active-day"]
                                                : [];
                                        }}
                                        dayHeaderDidMount={(arg) => {
                                            arg.el.style.cursor = "pointer";

                                            const isToday = moment(
                                                arg.date
                                            ).isSame(moment(), "day");

                                            if (isToday) {
                                                arg.el.style.background =
                                                    "#dee2e5"; // light highlight
                                                arg.el.style.borderBottom =
                                                    "none";
                                                arg.el.style.borderRadius =
                                                    "30px";
                                                arg.el.style.fontWeight = "700";
                                            }
                                            arg.el.addEventListener(
                                                "click",
                                                () => {
                                                    skipNextDatesSet.current = true;

                                                    const clickedDay = moment(
                                                        arg.date
                                                    ).startOf("day");
                                                    const prevSelected =
                                                        selectedDayRef.current;

                                                    const isSameDay =
                                                        prevSelected &&
                                                        moment(
                                                            prevSelected
                                                        ).isSame(
                                                            clickedDay,
                                                            "day"
                                                        );

                                                    if (isSameDay) {
                                                        setSelectedDay(null);
                                                        selectedDayRef.current =
                                                            null;
                                                    } else {
                                                        const nextDay =
                                                            clickedDay.toDate();
                                                        setSelectedDay(nextDay);
                                                        selectedDayRef.current =
                                                            nextDay;

                                                        arg.view.calendar.gotoDate(
                                                            arg.date
                                                        );
                                                    }
                                                }
                                            );
                                        }}
                                        eventDidMount={(info) => {
                                            const { status } =
                                                info.event.extendedProps;
                                            const eventStartDate =
                                                info.event.start;

                                            const eventEndDate = info.event.end;
                                            const currentDate = new Date();
                                            if (
                                                currentDate >= eventStartDate &&
                                                currentDate <= eventEndDate &&
                                                status !== "Sold out"
                                            ) {
                                                info.el.style.backgroundColor =
                                                    "#DBFAE3";
                                            } else {
                                                if (
                                                    currentDate < eventStartDate
                                                ) {
                                                    info.el.style.backgroundColor =
                                                        "white";
                                                } else {
                                                    // info.el.style.backgroundColor =
                                                    //     "#D3D3D3";
                                                }
                                            }
                                        }}
                                        eventContent={(eventInfo) => {
                                            const { price, liked, title_ar } =
                                                eventInfo.event.extendedProps;
                                            const id = eventInfo.event.id;
                                            const heartImage = liked
                                                ? "img/heart-icon-r.svg"
                                                : "img/heart-icon.svg";
                                            const startDate = moment(
                                                eventInfo.event.start
                                            ).format("DD/MM/YYYY");
                                            const endDate = moment(
                                                eventInfo.event.end
                                            ).format("DD/MM/YYYY");
                                            const startTime = moment(
                                                eventInfo.event.start
                                            ).format("hh:mmA");
                                            const endTime = moment(
                                                eventInfo.event.end
                                            ).format("hh:mmA");

                                            const showOnlyTime =
                                                startDate === endDate;
                                            return (
                                                <ul
                                                    className={`calender-list ${isHorizontal ? "list" : "grid"}`}
                                                >
                                                    <DiscoverCard
                                                        ele={{
                                                            ...(eventInfo?.event
                                                                ?.extendedProps ??
                                                                {}),
                                                            property_name:
                                                                eventInfo?.event
                                                                    ?.title ??
                                                                "",
                                                            property_name_ar:
                                                                eventInfo?.event
                                                                    ?.extendedProps
                                                                    ?.title_ar ??
                                                                "",
                                                        }}
                                                        syncData={
                                                            socketData?.find(
                                                                (s) =>
                                                                    s.property_id ===
                                                                    eventInfo
                                                                        .event
                                                                        .extendedProps
                                                                        .originalId
                                                            ) || null
                                                        }
                                                        view={
                                                            isHorizontal
                                                                ? "list"
                                                                : "grid"
                                                        }
                                                        layout="calendar"
                                                    />
                                                </ul>
                                            );
                                        }}
                                    />
                                </div>
                                {isHorizontal && (
                                    <div className="mt20">
                                        <div>
                                            <div
                                                className={`calender-list ${isHorizontal ? "list" : "grid grid-top"}`}
                                            >
                                                {cards(
                                                    currentBaseData,
                                                    "current"
                                                )?.length > 0 ? (
                                                    cards(
                                                        currentBaseData,
                                                        "current"
                                                    )
                                                ) : (
                                                    <span className="no-data">
                                                        No data found
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <DeleteConfirmationModal
                    title={t("Remove from favourite?")}
                    content={t(
                        "Are you sure about removing it from your favourite collections?"
                    )}
                    handleModalCancel={() =>
                        dispatch(handleDeleteConfirmationModal(false))
                    }
                    handleModalOpen={() =>
                        dispatch(handleDeleteConfirmationModal(true))
                    }
                    handleModalConfirm={() => {
                        submitReaction();
                        dispatch(handleDeleteConfirmationModal(false));
                    }}
                />
            </section>
        </>
    );
};

export default Events;
